// import Header from "./components/Header";
// import About from "./components/About";
// import TeamInfo from "./components/TeamInfo";
// import Contact from "./components/Contact";
// import Footer from "./components/Footer";

const styles = `
  body {
    margin: 0;
    padding: 0;
    background: #ffffff;
    font-family: Arial, Helvetica, sans-serif;
    color: #111111;
  }

  .container {
    max-width: 650px;
    margin: 0 auto;
    padding: 30px 20px;
    text-align: center;
  }

  a {
    color: #4c96d7;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto 25px auto;
  }

  p {
    font-size: 18px;
    line-height: 1.5;
    margin: 0 auto;
    max-width: 720px;
  }

  @media (max-width: 600px) {
    .container {
      padding: 24px 16px;
    }

    p {
      font-size: 16px;
    }
  }
`;

function App() {
  return (
    // <div>
    //   <Header />
    //   <About />
    //   <TeamInfo />
    //   <Contact />
    //   <Footer />
    // </div>
    <div className="container">
      <style>{styles}</style>
      <a href="https://brand-spec.com/">
        <img
          src={process.env.PUBLIC_URL + "/PremierSalesSE+BrandSpec.jpg"}
          alt="Premier Southeast Sales plus Brand Spec"
        />
      </a>

      <p>
        <strong>
          Premier Southeast Sales is now part of the Brand Spec family.
        </strong>
      </p>
      <p>
        We're excited to join forces with Brand Spec, a team that shares our
        commitment to strong relationships, exceptional service, and industry
        expertise. This partnership expands our capabilities across the
        Southeast while allowing us to continue delivering the trusted support
        and manufacturer representation our customers and partners have come to
        expect.
      </p>
      <p>
        <em>
          Updated <a href="https://brand-spec.com/">brand-spec.com</a> coming
          soon!
        </em>
      </p>
      <p>
        <a href="mailto:office@brand-spec.com">Contact Brand Spec</a>
      </p>
    </div>
  );
}

export default App;
